import { useRouter } from 'next/router'

import { SEO_DEFAULT_LOCALE, SeoLocale, isSeoLocale } from './constants'

/**
 * The locale the page renders in, narrowed to one the SEO copy is written for.
 *
 * Shared so the route, the menu and the category roots cannot disagree about what the
 * router's locale means. Its own module rather than seoRoute's: the menu reaches for it
 * from inside BaseLayout's header, and seoRoute imports SeoPage, which renders BaseLayout.
 */
export const useSeoLocale = (): SeoLocale => {
  const { locale, defaultLocale } = useRouter()
  const language = locale ?? defaultLocale

  return isSeoLocale(language) ? language : SEO_DEFAULT_LOCALE
}
